export default __webpack_public_path__ + "static/media/headervideo.7d92955d.gif";